import Request from '../../../../../src/core/gd/data/request'

export default class ApiEmailTemplate {

    constructor() {}

    static selectAll() {
        return new Request(this,'GET','company/email-templates')
    }

    static selectById(id:ID) {
        return new Request(this,'GET','company/email-templates/'+id)
    }

    static update(id:ID, payload:any) {
        return new Request(this,'PUT','company/email-templates/'+id, payload)
    }

    static create(payload:any) {
        return new Request(this,'POST','company/email-templates/create', payload)
    }

    static delete(id:ID) {
        return new Request(this,'DELETE','company/email-templates/'+id)
    }

}
